import storage from '../../utils/storage'

const STORAGE_KEY_TASKS = 'tr_v3_tasks_real'
const STORAGE_KEY_CURRENT_TASK = 'tr_v3_current_task_real'

export default {
  state: {
    tasksList: storage.get('tr_v3_tasks_real') || [],
    currentTask: storage.get('tr_v3_current_task_real') || null
  },
  mutations: {
    SET_TASKS_LIST(state, list) {
      state.tasksList = list
      storage.set(STORAGE_KEY_TASKS, list)
    },
    SET_CURRENT_TASK(state, task) {
      state.currentTask = task
      if (task) {
        storage.set(STORAGE_KEY_CURRENT_TASK, task)
      } else {
        storage.remove(STORAGE_KEY_CURRENT_TASK)
      }
    },
    CLEAR_CURRENT_TASK(state) {
      state.currentTask = null
      storage.remove(STORAGE_KEY_CURRENT_TASK)
    },
    ADD_TASK(state, task) {
      state.tasksList.push(task)
      storage.set(STORAGE_KEY_TASKS, state.tasksList)
    },
    UPDATE_TASK(state, task) {
      const idx = state.tasksList.findIndex(t => t.task_id === task.task_id)
      if (idx >= 0) {
        state.tasksList.splice(idx, 1, task)
        storage.set(STORAGE_KEY_TASKS, state.tasksList)
      }
      if (state.currentTask && state.currentTask.task_id === task.task_id) {
        state.currentTask = task
        storage.set(STORAGE_KEY_CURRENT_TASK, task)
      }
    },
    DELETE_TASK(state, taskId) {
      state.tasksList = state.tasksList.filter(t => t.task_id !== taskId)
      storage.set(STORAGE_KEY_TASKS, state.tasksList)
      if (state.currentTask && state.currentTask.task_id === taskId) {
        state.currentTask = state.tasksList[0] || null
        if (state.currentTask) {
          storage.set(STORAGE_KEY_CURRENT_TASK, state.currentTask)
        } else {
          storage.remove(STORAGE_KEY_CURRENT_TASK)
        }
      }
    }
  },
  actions: {
    initCurrentTask({ state, commit }, { taskId }) {
      const list = state.tasksList
      if (!list || !list.length) return

      const target = list.find(t => String(t.task_id) === String(taskId))
      if (target) {
        commit('SET_CURRENT_TASK', target)
      } else if (!state.currentTask) {
        commit('SET_CURRENT_TASK', list[0])
      }
    },
    switchTask({ commit, state }, taskId) {
      const target = state.tasksList.find(t => String(t.task_id) === String(taskId))
      if (target) {
        commit('SET_CURRENT_TASK', target)
        commit('SET_CURRENT_EVALUATION', null)
        return target
      }
      return null
    }
  },
  getters: {
    tasksList: state => state.tasksList,
    currentTask: state => state.currentTask,
    currentTaskId: state => (state.currentTask && state.currentTask.task_id) || null,
    taskById: state => id => state.tasksList.find(t => String(t.task_id) === String(id)),
    myTasks: (state, getters, rootState) => {
      const user = rootState.user
      if (!user) return []
      if (user.role === 'super_admin') return state.tasksList
      const userTaskIds = user.task_ids || []
      return state.tasksList.filter(t => userTaskIds.includes(t.task_id))
    },
    isCurrentTaskExpired: (state) => {
      const task = state.currentTask
      if (!task || !task.end_date) return false
      const today = new Date()
      today.setHours(0, 0, 0, 0)
      const end = new Date(task.end_date)
      end.setHours(0, 0, 0, 0)
      return today > end
    }
  }
}
